import { FormActionButton } from '@workwave-tidal/core/form'
import { useEditingStateWithCtx } from '@/atoms'
import { useTexts } from '../hooks/useTexts'
import { form } from '../formState'

export function Footer() {
  const { resetEditing } = useEditingStateWithCtx('driver')

  const { footer } = useTexts()

  const {
    meta: { submitting, validating, status },
  } = form.useFormMeta()

  // When creating a new entity the submit button should be enabled also when the form is in a pristine status
  const saveDisabled = status === 'pristine' || validating || submitting

  return (
    <>
      <FormActionButton
        label={footer.cancel}
        onClick={resetEditing}
        testId="footer-secondary-button"
      />
      <FormActionButton
        label={footer.save}
        variant="contained"
        type="submit"
        disabled={saveDisabled}
        loading={submitting || validating}
        testId="footer-primary-button"
      />
    </>
  )
}
